import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { ELegalDocType } from "@shared/enums/legal-doc-type.enum";

@Component({
  selector: "app-footer-info-links",
  imports: [TranslatePipe, RouterLink],
  templateUrl: "./footer-info-links.component.html",
  styleUrls: ["./footer-info-links.component.scss"],
})
export class FooterInfoLinksComponent {
  protected readonly ELegalDocType = ELegalDocType;
}
